import { useTermsByTaxonomy } from './useTerms';

/**
 * Hook to fetch industries from the Industries taxonomy
 *
 * This is a convenience wrapper around useTermsByTaxonomy
 * for fetching industry options for client forms.
 */
export const useIndustries = () => {
  const {
    data: industries = [],
    isLoading,
    error,
  } = useTermsByTaxonomy('industries');

  return {
    industries,
    loading: isLoading,
    error: error ? (error as Error).message : null,
  };
};
